<template>
<el-dialog @close='cancel' title="添加商品" :visible.sync="dialogVisible">
    <div class="ueditor add_goods_box">
        <div class="left_menu_box">
            <!--<div class="top_box">全部商品</div>-->
            <div class="shop_list" v-for="(obj, index) of activeList" :key="index" @click="handleClick(obj)">
                <div :class="[activeName==obj.name?'is_select':'']" class="listItem">
                    <span class="el-dropdown-link">
                        {{obj.label}}
                    </span>
                    <i class="el-icon-arrow-down el-icon--right"></i>
                </div>
            </div>
        </div>
        <div class="right_main_box">
            <div class="add_goods_search_box">
                <el-input placeholder="输入商品名称" v-model="param.kmcname" clearable></el-input>
                <el-button type="primary" @click="handelQuery" plain>搜索</el-button>
            </div>
            <div class="add_goods_tabs_box">
                <el-table :data="tableData" style="width: 100%" :show-header="false" @select="handleSelectionChange">
                    <el-table-column type="selection" width="30"></el-table-column>
                    <el-table-column label="商品信息">
                        <template slot-scope="scope">
                            <div class="goods_item_box">
                                <img v-lazy="scope.row.logoPic.furl" alt>
                                <div>
                                    <p>{{scope.row.kmcname}}</p>
                                    <p :class="scope.row.isFree === 1 ? 'free' : 'toll'">{{scope.row.isFree === 1 ? scope.row.isFreeText : scope.row.salePrice}}</p>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="page" style="margin-top: 15px; text-align: center">
                <el-pagination
                    background
                    @current-change="handleSizeChange"
                    :current-page.sync="page.page"
                    :page-size="page.pageSize"
                    :pager-count="11"
                    layout="prev, pager, next"
                    :total="total">
                </el-pagination>
            </div>
            <div slot="footer" class="dialog-footer"  style="margin-top: 20px;">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureAdd()">确 定</el-button>
            </div>
        </div>
    </div>
</el-dialog>
</template>

<script>
import {findGoodsList} from 'api/materialMgtApi'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'shop',
    data() {
        return {
            activeList: [{label: '全部商品', name: 'all'}, {label: '图文', name: 'article'}, {label: '报告', name: 'report'}, {label: '视频', name: 'video'}, {label: '专题', name: 'spackage'}],
            activeName: 'all',
            param: {
                kmcname: '',
                kmctype: 1
            },
            page: {
                page: 0,
                pageSize: 5,
                pageCount: 0
            },
            total: 0,
            dialogVisible: false,
            tableData: [],
            selectedResult: [],
            flag: true,
            scrollTop: 0 // 上一次滚动距离
        }
    },
    mounted() {},
    methods: {
        handleSizeChange() {
            this._getList()
        },
        openDialog() {
            this.tableData = []
            this.dialogVisible = true
            this._getList()
        },
        cancel() {
            this.param.name = ''
            this.page = {
                page: 0,
                pageSize: 5,
                pageCount: 0
            }
            this.dialogVisible = false
        },
        handelQuery() {
            this.page.page = 0
            this.tableData = []
            this._getList()
        },
        // 添加分组弹窗Tabs
        handleClick(obj) {
            this.activeName = obj.name
            switch (obj.name) {
            case 'article':
                this.param.kmctype = 1
                break
            case 'report':
                this.param.kmctype = 2
                break
            case 'video':
                this.param.kmctype = 4
                break
            case 'spackage':
                this.param.kmctype = 5
                break
            }
            this.page.page = 0
            this.tableData = []
            this._getList()
        },
        // 获取不同类型下商品列表
        _getList() {
            this.page.page++
            this.setLoading(true)
            findGoodsList({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.page.pageCount = data.data.pageinfo.pageCount
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
            this.setLoading(true)
        },
        handleSelectionChange(selection, row) {
            let flag = true
            this.selectedResult.forEach((obj1, index1) => {
                if (obj1.objectid === row.kmcinnerid) {
                    flag = false
                    // this.selectedResult.splice(index1, 1)
                    delete this.selectedResult[index1]
                }
            })
            if (flag) {
                this.selectedResult.push({
                    objectid: row.kmcinnerid,
                    objectname: row.kmcname,
                    kmctype: row.kmctype,
                    viewcount: row.viewcount,
                    uprice: row.uprice,
                    saleprice: row.saleprice,
                    furl: row.logoPic.furl,
                    desc: row.desc
                })
            }
            this.selectedResult = this.selectedResult.filter(obj => obj)
        },
        // 确定添加商品
        sureAdd() {
            this.$emit('setShop', this.selectedResult)
            this.cancel()
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.ueditor.add_goods_box {
    display: flex;
    .left_menu_box{
        width: 150px;
        min-height: 500px;
        margin-right: 20px;
        border-right: 1px solid #DCDFE6;
        box-sizing: border-box;
        &>div{
            text-align: center;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            width: 150px;
            font-size:14px;
            font-family:PingFangSC-Regular;
            font-weight:400;
            color:rgba(48,49,51,1);
            box-sizing: border-box;
        }
        &>div:hover{
            background:rgba(230,241,252,1);
        }
        .top_box{
            // background:rgba(230,241,252,1);
            border-right: 4px solid transparent;
            text-align: right;
            padding-right: 36px;
            cursor: pointer;
        }
        .shop_list{
            .listItem{
                border-right: 4px solid transparent;
                padding-right: 15px;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                padding-right: 15px;
                width: 150px;
            }
            .el-dropdown-link {
                cursor: pointer;
            }
            .el-icon--right {
                margin-left: 20px;
            }
            .el-dialog__header{
                display: flex;
                justify-content: space-between;
            }
            .el-dropdown {
                display: flex;
                line-height: 1;
                span{
                    display: inline-block;
                    width: 74px;
                    overflow: hidden;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                }
            }
        }
        .is_select{
            background:rgba(230,241,252,1);
            border-right: 4px solid #409EFF !important;
            color:rgba(64,158,255,1);
            .el-dropdown-link{
                color:rgba(64,158,255,1);
            }
        }
    }
    .add_goods_search_box {
        display: flex;
        margin-bottom: 10px;
        .el-input {
            width: 240px;
        }
        .el-input__inner {
            height: 36px;
        }
        .el-input__icon {
            line-height: 36px;
        }
        .el-button,
        .el-button--mini {
            height: 36px;
            width: 96px;
            margin-left: 20px;
            margin-bottom: 0px;
        }
    }
    .add_goods_tabs_box {
        .el-table{
            min-height: 340px;
        }
        .goods_item_box {
            display: flex;
            align-items: center;
            height: 42px;
            box-sizing: border-box;
            & > img {
                display: block;
                width: 74px;
                min-width: 74px;
                max-height: 42px;
                height: 42px;
                margin-right: 10px;
            }
            & > div {
                & > p:nth-of-type(1) {
                    color: rgba(48, 49, 51, 1);
                    line-height: 18px;
                    margin-bottom: 4px;
                    width: 420px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    word-break: break-all;
                }
                & > p:nth-of-type(2) {
                    line-height: 20px;
                }
                .free {
                    color: rgba(64, 158, 255, 1);
                }
                .toll {
                    color: #f56c6c;
                }
            }
        }
        .el-table__empty-block {
            height: 340px;
            max-height: 340px;
        }
        .el-table__empty-text {
            position: relative;
            top: 80px;
        }
    }
    .el-table::before{
        height: 0;
    }
}
</style>
